class ProductUpsellSelector extends HTMLElement {
  constructor() {
    super();
    
    this.dropdown = null;
    this.selectedProduct = null;
    this.selectedVariantId = null;
  }

  connectedCallback() {
    const upsellDropdown = this.querySelector('custom-dropdown[data-type="upsell"]');
    if (!upsellDropdown) {
      return;
    }
    
    setTimeout(() => {
      this.dropdown = this.querySelector('custom-dropdown[data-type="upsell"]');
      
      if (this.dropdown && this.dropdown.dataset.type === 'upsell') {
        this.setupDropdown();
      }
    }, 100);
  }

  setupDropdown() {
    if (!this.dropdown || this.dropdown.dataset.type !== 'upsell') {
      return;
    }
    
    const options = this.dropdown.querySelectorAll('.variant-dropdown__option');
    const selectedText = this.dropdown.querySelector('.variant-dropdown__selected');
    
    if (!options || !selectedText || options.length === 0) {
      return;
    }
    

    if (!selectedText.dataset.placeholder) {
      selectedText.dataset.placeholder = selectedText.textContent.trim();
    }
    
    if (window.innerWidth <= 768) {
      const optionsContainer = this.dropdown.querySelector('.variant-dropdown__options');
      if (optionsContainer) {
        const overlay = document.createElement('div');
        overlay.className = 'variant-dropdown__overlay-mobile';
        overlay.addEventListener('click', () => {
          this.closeDropdown();
        });
        document.body.appendChild(overlay);
        this.overlay = overlay;
        
        const closeBtn = document.createElement('button');
        closeBtn.className = 'variant-dropdown__close-mobile';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML = `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;
        closeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.closeDropdown();
        });
        
        const header = optionsContainer.querySelector('.variant-dropdown__mobile-header');
        if (header) {
          let titleWrapper = header.querySelector('div:not(.variant-dropdown__close-mobile)');
          
          if (!titleWrapper) {
            const headerText = header.textContent.trim();
            if (headerText) {
              header.textContent = '';
              
              titleWrapper = document.createElement('div');
              titleWrapper.textContent = headerText;
              header.appendChild(titleWrapper);
            }
          }
          
          if (!header.querySelector('.variant-dropdown__close-mobile')) {
            header.appendChild(closeBtn);
          }
        } else {
          optionsContainer.insertBefore(closeBtn, optionsContainer.firstChild);
        }
      }
    }
    
    const trigger = this.dropdown.querySelector('.variant-dropdown__trigger');
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleDropdown();
      });
    }
    
    document.addEventListener('click', (e) => {
      if (!this.dropdown.contains(e.target) && this.dropdown.dataset.open === 'true') {
        this.closeDropdown();
      }
    });
    
    options.forEach((option) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.dropdown && this.dropdown.dataset.type === 'upsell') {
          const isAlreadySelected = option.classList.contains('selected');
          
          if (isAlreadySelected) {
            options.forEach((opt) => opt.classList.remove('selected'));
            selectedText.textContent = selectedText.dataset.placeholder || 'Select';
            selectedText.style.color = '#bcb6b4';
            
            this.selectedProduct = null;
            this.selectedVariantId = null;
            
            this.dispatchEvent(new CustomEvent('upsell-selected', {
              detail: {
                productId: null,
                variantId: null,
                title: null
              },
              bubbles: true
            }));
            
            setTimeout(() => {
              this.closeDropdown();
            }, 10);
            return;
          }
          
          this.selectProduct(option, selectedText);
        }
      });
    });
  }

  selectProduct(optionElement, selectedTextElement) {
    const productTitle = optionElement.dataset.productTitle;
    const variantId = optionElement.dataset.variantId;
    const productId = optionElement.dataset.productId;
    
    this.selectedProduct = {
      id: productId,
      variantId: variantId,
      title: productTitle
    };
    this.selectedVariantId = variantId;
    
    selectedTextElement.textContent = productTitle;
    selectedTextElement.style.color = '#534949';
    
    const options = this.dropdown.querySelectorAll('.variant-dropdown__option');
    options.forEach((opt) => opt.classList.remove('selected'));
    optionElement.classList.add('selected');
    
    this.dispatchEvent(new CustomEvent('upsell-selected', {
      detail: {
        productId: productId,
        variantId: variantId,
        title: productTitle
      },
      bubbles: true
    }));
    
    this.closeDropdown();
  }

  toggleDropdown() {
    const isOpen = this.dropdown.dataset.open === 'true';
    if (isOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    if (this.dropdown.dataset.disabled === 'true') {
      return;
    }
    
    this.dropdown.dataset.open = 'true';
    
    if (window.innerWidth <= 768) {
      if (this.overlay) {
        this.overlay.classList.add('show');
      }
      
      const scrollY = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      this.scrollY = scrollY;
      
      const container = this.dropdown.querySelector('.variant-dropdown__options');
      if (container) {
        container.offsetHeight;
        container.style.transform = '';
        container.style.opacity = '';
      }
    }
  }

  closeDropdown() {
    const container = this.dropdown.querySelector('.variant-dropdown__options');
    
    if (container && window.innerWidth <= 768) {
      if (this.overlay) {
        this.overlay.classList.remove('show');
      }
      
      container.style.transform = 'translateY(100%)';
      container.style.opacity = '0';
      container.style.visibility = 'hidden';
      
      setTimeout(() => {
        this.dropdown.dataset.open = 'false';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        
        if (this.scrollY !== undefined) {
          window.scrollTo(0, this.scrollY);
          this.scrollY = undefined;
        }
        
        container.style.transform = '';
        container.style.opacity = '';
        container.style.visibility = '';
      }, 300);
    } else {
      this.dropdown.dataset.open = 'false';
    }
  }

  getSelectedProduct() {
    return this.selectedProduct;
  }

  clearSelection() {
    const selectedText = this.dropdown?.querySelector('.variant-dropdown__selected');
    if (selectedText) {
      selectedText.textContent = 'Select';
      selectedText.style.color = '#bcb6b4';
    }
    
    const options = this.dropdown?.querySelectorAll('.variant-dropdown__option');
    options?.forEach((opt) => opt.classList.remove('selected'));
    
    this.selectedProduct = null;
    this.selectedVariantId = null;
  }
}

if (customElements.get('product-upsell-selector') === undefined) {
  customElements.define('product-upsell-selector', ProductUpsellSelector);
}

